import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  message?: string;
};

const PlanActionResultDialog = ({ open, onOpenChange, title = 'Success', message = '' }: Props) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white p-6 sm:p-8 rounded-2xl shadow-2xl w-[90%] max-w-[360px] sm:max-w-[480px] border-0">
        <DialogHeader>
          <div className="text-center space-y-4">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
              <CheckCircle className="w-8 h-8 text-green-600" />
            </div>
            <DialogTitle className="text-lg font-semibold text-[#1C1F26] leading-[26px]">
              {title}
            </DialogTitle>
            <p className="text-sm text-gray-600">{message}</p>
          </div>
        </DialogHeader>
        <DialogFooter className="flex flex-col sm:flex-row gap-3 pt-6">
          <Button
            onClick={() => onOpenChange(false)}
            className="w-full"
          >
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PlanActionResultDialog;
